function scrollToTop() {
    var scrollToTopBtn = document.getElementsByClassName("scrollToTop")[0]; // Get the first element in the collection

    // Add a click event listener to the button
    scrollToTopBtn.addEventListener("click", function() {
        // Scroll to the top of the page smoothly
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });

    window.onscroll = function() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            scrollToTopBtn.style.display = "block";
        } else {
            scrollToTopBtn.style.display = "none";
        }
    };
}

scrollToTop();



